export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ03.74b7029c.mp3";